import './List.css'

import React, { Dispatch, SetStateAction, useCallback, useEffect, useRef, useState } from 'react'
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import L, { LatLngExpression } from 'leaflet'
import { CurrentSession } from '@/services/repository/session'
import { Services } from '@/services/services'
import { useNavigate } from 'react-router-dom'
import { useModal } from '@/components/modal/Modal'
import { defaultMapCenter } from '@/env/config'
import { StaticPaginatedTable, StaticPaginatedTableState } from '@/components/search/StaticPaginatedTable'
import { MapPopupBody, MapRow, vehicleObject } from '@/components/Map/Map'
import { MapResponse, MapRowMachine } from './Response'
import { Order, OrderManager } from './Order'


export const MachineStatisticListOrderCols: string[] = ['machine.type.manufacturer', 'machine.type.category', 'machine.type.model', 'machine.internalNumber'] //'machine.name',
export const MachineStatisticListDefaultOrder: Order = {
  key: 'machine.type.manufacturer',
  asc: true
}

export const MachineStatisticList = ({ services, session, data, selected, onSelect, parentState, setParentState, orderManager }: {
  services: Services
  session: CurrentSession
  data: MapResponse | undefined
  selected: MapRowMachine | undefined
  onSelect: (m: MapRowMachine | undefined) => void
  parentState: StaticPaginatedTableState
  setParentState: Dispatch<SetStateAction<StaticPaginatedTableState>>
  orderManager: OrderManager
  // setOrderManager: Dispatch<SetStateAction<OrderManager>>
}) => {
  const navigate = useNavigate()
  const [ordered, setOrdered] = useState<MapRow[]>()

  useEffect(() => {
    let ordered = orderManager.orderListByKey(data?.rows || [])
    setOrdered(ordered)
  }, [data, orderManager])

  if (data === undefined || !ordered) {
    return <div className='spinner'></div>
  }

  function headerRow(key: string, transKey?: string): React.ReactElement {
    transKey = transKey ? transKey : key
    return <div className='hcol' onClick={() => orderManager.click(key)}>
      {session.translates.for('elements.table.machines.' + transKey)}
      {orderManager.orderInfoElement(key)}
    </div>
  }

  return <div className='statistic-machine-list'>
    <StaticPaginatedTable<MapRow>
      data={ordered || []}
      // initialState={{
      //   pageSize: 5
      // }}
      parentState={parentState}
      setParentState={setParentState}
      header={() => <>
        {/* {headerRow('machine.name', 'name')} */}
        {headerRow('machine.type.manufacturer', 'manufacturer')}
        {headerRow('machine.type.category', 'type_category')}
        {headerRow('machine.type.model', 'model')}
        {headerRow('machine.internalNumber', 'internal_number')}
        <div className='hcol'></div>
      </>}
      row={(row) => {
        const isRowSelected = selected !== undefined && row.machine.id === selected.id
        let selectedClass = selected !== undefined ? (row.machine.id === selected.id ? 'col-selected' : 'col-unselected') : ''
        const select = () => isRowSelected ? onSelect(undefined) : onSelect(row.machine)
        return <>
          {/* <div className={`col ${selectedClass}`} onClick={select}>{row.machine.name}</div> */}
          <div className={`col ${selectedClass}`} onClick={select}>{row.machine.type.manufacturer}</div>
          <div className={`col ${selectedClass}`} onClick={select}>{row.machine.type.category ? session.translates.for(`machine.types.${row.machine.type.category}`) : null}</div>
          <div className={`col ${selectedClass}`} onClick={select}>{row.machine.type.model}</div>
          <div className={`col ${selectedClass}`} onClick={select}>{row.machine.internalNumber || row.machine.id}</div>
          <div className={`col icocol ${selectedClass}`} onClick={() => navigate(`/communal/machine/${row.machine.id}`)}>
            <i className='svgfont-next' />
          </div>
        </>
      }}
      translates={session.translates}
    />
  </div>
}

